import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeUserTab } from "@/__mocks__/user";
import { HeaderDecorator } from "@/__stories__/Decorator";
import type { ModalTitleHeaderProps } from "@/ui/composed/modal/ModalTitleHeader";
import ModalTitleHeader from "@/ui/composed/modal/ModalTitleHeader";
import { FAIconName, IconButton, UserTabSelector } from "@/ui/core";
import { joinTestIDs } from "@/utils/string.util";

const baseTestID = "modal-title-header";

const mockUserTabs = faker.helpers.multiple(() => fakeUserTab(), {
  count: { max: 10, min: 2 },
});

const StoryMeta: Meta<ModalTitleHeaderProps> = {
  title: "Components/Modal/Title Header",
  component: ModalTitleHeader,
  argTypes: {
    onDismiss: { action: "dismissed" },
    testID: { control: "text" },
    title: { control: "text" },
  },
  args: {
    testID: baseTestID,
    title: "Important Event",
  },
  decorators: [(story) => <HeaderDecorator>{story()}</HeaderDecorator>],
};

type Story = StoryObj<ModalTitleHeaderProps>;

const Primary: Story = {};
const WithButtons: Story = {
  render: (props) => (
    <ModalTitleHeader
      {...props}
      actionComponents={
        <>
          <IconButton
            iconName={FAIconName.CalendarCirclePlus}
            onPress={() => console.log("Add event")}
            testID={joinTestIDs(baseTestID, "add-event")}
          />
          <IconButton
            iconName={FAIconName.Trash}
            onPress={() => console.log("Delete event")}
            testID={joinTestIDs(baseTestID, "delete-event")}
            variant="accent.critical"
          />
        </>
      }
    />
  ),
};

const WithUserSelector: Story = {
  render: (props) => (
    <ModalTitleHeader
      {...props}
      actionComponents={
        <UserTabSelector
          appUserId="x"
          onUserChange={() => console.log("User changed")}
          tabs={mockUserTabs}
          testID={baseTestID}
        />
      }
    />
  ),
};

export { Primary, WithButtons, WithUserSelector };
export default StoryMeta;
